import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Loading from "../../loading";
// import './individualblog.css'
import {Helmet} from "react-helmet";
import axios from "axios";

const styles = (theme) => ({
  card: {
    maxWidth: 390,
    width: "80%",
    margin: "0 auto",
    padding: 10,
    backgroundColor: "whitesmoke",
  },
  cardContent: {
    paddingBottom: 0,
    textAlign: "justify",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
    borderBottomRadius: 10,
  },
});

export class IndividualBlog extends Component {
  constructor() {
    super();
    this.state = {
      articles: [],
      loading: true,
      done: false,
    };
  }

  componentDidMount() {
    var id = window.location.pathname.split('/')[3];
    console.log(id)
    this.setState({
      loading: true,
      done: false,
    });
    axios.get(`https://djaura.pythonanywhere.com/ar/${id}`).then((response) => {
      let items = response.data;
      let newState = [];
      response.data.article.split("\n").map((item, i) => {
        return newState.push(item);
      });
      var date = items.article_date.split("T")[0];
      date = date.split("-");
      date = date[2] + " / " + date[1] + " / " + date[0];
      this.setState({
        id: items.article_id,
        author: items.article_author,
        description: items.article_desc,
        title: items.article_title,
        date: date,
        article: items.article,
        image: items.article_img,
        articles: newState,
        loading: false,
      });
    });
  }

  split() {
    let newState = [];
    // let newText = this.state.article.split("\\n").map((item, i) => {
    //   return newState.push(item);
    // });
    this.setState({
      articles: newState,
    });
  }
  render() {
    const {
      title,
      author,
      loading,
      image,
      date,
    } = this.state;
    const titlealone=title
    return (
      <div>
       
        <div className="center paper">
          {loading ? (
            <Loading />
          ) : (
              
            <Grid container spacing={0} className="center blogs">
                 <Helmet>
          <title>{titlealone  + ' || AURA'}</title>
          <meta
            name="description"
            content="The place where we showcase the talent of our brilliant writers."
          />
        </Helmet>
              <Grid item md={4} xs={12}>
                <Grid
                  container
                  spacing={0}
                  className="imageTop fadeInUp"
                  style={{ animationDelay: "0.5s" }}
                >
                  <Grid item xs={12}>
                    <div id="image">
                      <img alt ={title} src={image}  />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                md={8}
                xs={12}
                className="fadeInUp"
                style={{ animationDelay: "0.5s" }}
              >
                <Grid container spacing={0}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <p className="feature">{title}</p>
                  </Grid>
                  <Grid item xs={12}>
                    {this.state.articles.map((art,index) => {
                      return (
                        <Typography paragraph key={index} align="left">
                          {art.trim() !== 0 ? art : <br />}
                        </Typography>
                      );
                    })}
                  </Grid>
                  <Hidden only={["xs", "sm"]}>
                    <Grid item xs={12}>
                      <p className="featureHeader">{author}</p>
                      <p className="featureHeader">{date}</p>
                    </Grid>
                  </Hidden>
                  <Hidden only={["ms", "lg", "xl"]}>
                    <Grid item xs={12}>
                      <p className="featureHeader-sm">
                        {author} || {date}
                      </p>
                    </Grid>
                  </Hidden>
                </Grid>
              </Grid>
            </Grid>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(IndividualBlog);
